export const customEvent = type => (obj = { detail: null }) =>
  new CustomEvent(type, obj);

export const dispatchCustomEvent = customEvent => elem =>
  elem.dispatchEvent(customEvent);
